import {SyncUIActDecorator} from '@gongxigames/framework/slotV2/fsm/acts/decorators/SyncUIActDecorator';

export class JurisdictionZoneUpdateSessionBetUIAct extends SyncUIActDecorator {
    public execute(): void {
        this.emitter.emit('UI.command.updateSessionBet');
        this.onExecuted?.();
    }

    getName(): string {
        return 'JurisdictionZoneUpdateSessionBetUIAct';
    }
}